<template>
    <v-app :dark="darkTheme">
        <v-navigation-drawer dark dense transparent persistent :mini-variant="miniVariant" :clipped="clipped" v-model="drawer" enable-resize-watcher fixed app width="190"> 
            <div flat color="transparent" class="leftnav-avatar-box text-xs-center" @click="viewMyProfile" title="View MyProfile">
                <v-avatar size="55" to="/myprofile">
                    <user-avatar-card></user-avatar-card> 
                </v-avatar>
                <div v-show="!miniVariant" class="white--text caption mt-5">{{ this.$store.state.name }}</div>
            </div>   
            <v-list dense>
                <v-list-tile to="/" ripple title="My Dashboard"> 
                    <v-list-tile-action>
                        <v-icon>dashboard</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content class="leftnav-content-text">
                    <v-list-tile-title>My Dashboard</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-for="(item,index) in user_apps_list" :key="index" dense :prepend-icon="item.appIcon" :title="item.appTitle" :to="item.appPath">
                    <v-list-tile-action>
                        <v-icon>{{item.appIcon}}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content class="leftnav-content-text">
                        <v-list-tile-title>{{item.appName}}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile> 
            </v-list>
            <div class="text-xs-right leftnav-mini-button">
                <v-btn small icon @click.stop="setLeftMiniUpper" >
                    <v-icon small v-show="miniVariant">chevron_right</v-icon>
                    <v-icon small v-show="!miniVariant">chevron_left</v-icon>
                </v-btn>   
            </div> 
        </v-navigation-drawer>
      
        <v-toolbar app clipped-left height="43" clipped-right color="primary" dark >
            <v-toolbar-side-icon @click.stop="drawer=!drawer">
                <v-icon v-if="!isMobile">menu</v-icon>
                <v-avatar v-else size="30">
                    <user-avatar-card></user-avatar-card> 
                </v-avatar>
            </v-toolbar-side-icon>   
            <v-toolbar-title class="pl-0 ml-0">
                <span class="logo-text">SweldoNow</span>
            </v-toolbar-title>         
            <v-spacer></v-spacer>
            
            <!-- Linked Account  -->
            <v-chip  v-if="isManagingLinkedAccount&&isMobile" @click="dialogOkCancel=true" small outline class="white" label>
                <span class="caption white--text">Linked Account</span>
            </v-chip>
            <v-btn v-if="isManagingLinkedAccount&&!isMobile" @click="dialogOkCancel=true" outline small title="Click to switch back to your parent account.">
                {{ linkedAccountCompanyName }}
            </v-btn>
            
            <!-- Plan Type -->
            <plan-type></plan-type>

            <v-btn v-if="!isMobile" icon @click="viewHelp" title="Knowledge Hub">
                <v-icon>help_outline</v-icon>
            </v-btn>
            <v-btn v-if="!isMobile" icon to="/mysettings" title="My Settings">
                <v-icon>settings</v-icon>
            </v-btn>
            <v-btn @click="hasNewNotifications=false" icon to="/notifications" title="Notifications">
                <v-badge v-model="hasNewNotifications" overlap small color="orange">
                    <template v-slot:badge v-if="hasNewNotifications">
                        <span class="caption">{{notications}}</span>
                    </template>
                    <v-icon>
                        notifications
                    </v-icon>
                </v-badge>
            </v-btn>
          
            <v-toolbar-items>
                <v-menu left offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn flat icon v-on="on" title="My Profile, Logout">
                            <v-icon>apps</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-tile>
                            <v-btn icon to="/myprofile" title="My Profile">
                                <v-icon class="pt-5">account_box</v-icon>
                            </v-btn>
                        </v-list-tile>
                        <v-list-tile>
                            <v-btn icon to="/features" title="Features">
                                <v-icon class="pt-5">featured_play_list</v-icon>
                            </v-btn>
                        </v-list-tile>
                        <v-list-tile v-if="isMobile" >
                            <v-btn icon @click="viewHelp" title="Knowledge Hub">
                                <v-icon>help_outline</v-icon>
                            </v-btn>
                        </v-list-tile>
                        <v-list-tile v-if="isMobile" >
                            <v-btn icon to="/mysettings" title="My Settings">
                                <v-icon>settings</v-icon>
                            </v-btn>
                        </v-list-tile>
                        <v-list-tile>
                            <v-btn icon @click="logout" title="Logout">
                                <v-icon>power_settings_new</v-icon> 
                            </v-btn>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>
  
        <v-content>
            <v-container fluid grid-list-md pa-0>
                <v-layout row wrap>
                    <v-flex xs12>

                        <header-card ref="refHederCard"                            
                            :title = "headerTitle"
                            :isMainMenu = "isMainMenu"
                            :pageTitle = "headerPageTitle" 
                            :avatarPath = "avatarPath" 
                            :companyLogo = "companyLogo"
                            :headerImgPath = "headerImgPath"
                            :isTeamPage = "isTeamPage">
                        </header-card>

                        <router-view class="content-container"></router-view>
                    </v-flex>
                </v-layout> 
            </v-container>
        </v-content>
        
        <notif-badge @refresh="updateNotifBadge"></notif-badge>
        <v-snackbar v-model="showSnackbar" color="warning" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="0" :top="y === 'top'" :vertical="mode === 'vertical'"
            >{{ snackBarMsg }}
            <v-btn color="black" flat @click="showSnackbar=false">Close</v-btn>
        </v-snackbar>
        <v-dialog v-model="dialogOkCancel" persistent width="600">
            <ok-cancel :msg="dialogOkCancelMsg" :dialogOkCancel.sync="dialogOkCancel" @ok="loginToParentAccount"></ok-cancel>
        </v-dialog>
    </v-app>
  </template>
  
<script>

import userApi from '@/api/user.js'
import appsApi from '@/api/applications'
import fiscalPeriodsApi from '@/api/fiscalperiods'
import auth from '@/auth/auth.js' 
import notificationsApi from '@/api/notifications'
import colorlist from '@/common/color_themes'
import { updateMobileSystemBar } from '@/helpers/system-panel-settings'

export default {
    name: 'App',
    metaInfo: {
    title: 'Dashboard',
    titleTemplate: '%s - SweldoNow',
    meta: [
        { charset: 'utf-8' },
        { name: 'description', content: 'View My Team Status today, whose working which task, View Upcoming   , Time Offs, Birthdays. View Alerts, For approvals.' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    ]
    },
    components: {
        'header-card': () => import('@/components/Common/Header'),
        'user-avatar-card': () => import('@/components/Users/UserAvatar') ,
        'notif-badge': () => import('@/components/Common/NotificationsBadge'),
        'ok-cancel': ()=> import("@/components/BasicPopups/OkCancel"),
        'plan-type': () => import('@/components/Common/PlanType'),
    },
    data () {
        return {
            drawerRight: false,
            miniRight: true,
            clipped: true,
            drawer: false,
            fixed: false,
            miniVariant: false,
            right: true,
            darkTheme: false,
            hasNewNotifications: false,
            // header_display: false,
            headerTitle: null,
            isMainMenu: false,
            headerPageTitle: null,
            avatarPath: null,
            headerImgPath: null,
            isTeamPage: false,
            companyLogo: null,
            user_apps_list: [],
            login_timer: null,
            showSnackbar: false,
            dialogOkCancel: false,
            mode: null,
            x: null,
            y: null,
            snackBarMsg: ''
        }
    },
    methods: {
        async loginToParentAccount() {
            try {
                this.dialogOkCancel = true
                const parentUserId = this.$store.state.parentUserId
                await auth.switchAccount(parentUserId)
                if (auth.loggedIn()) {
                    this.dialogOkCancel = false
                    this.$router.push("/")
                    this.initialize()
                    this.$refs.refHederCard.setHeaderImageMain()
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewHelp() {
            window.open('https://help.sweldonow.ph')
        },
        async getUnreadNotifications() {
            try {
                const response = await notificationsApi.getUnread()
                if (response.status == 200) {
                    this.$store.commit('setUnclickedNotifCount', response.data)
                    this.hasNewNotifications = parseInt(response.data) > 0
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewMyProfile(){
            this.$router.push('/myprofile')
        },
        setHeaderImage() {
            var selectedColor = this.colorlist.find(item => {
                return this.formatHeaderImage(item.title) == this.formatHeaderImage(this.$store.state.color) || (item.hex == this.$store.state.color)
            })
            if (selectedColor) {
                var headerImage = `${this.formatHeaderImage(selectedColor.title)}.jpg`
                this.$store.commit('setHeaderImage', headerImage)
            }
        },
        formatHeaderImage(imgFileName) {
            return imgFileName.toLowerCase().replace('.darken1','').replace('.darken2','').replace('.darken3','').replace('.darken4','')  
        },
        setUserSettings() {
            // 1. Theme configuration
            this.darkTheme = this.$store.state.theme == 'dark' ? true : false

            // 2. Find the active color item directly using .find()
            const activeColorItem = this.colorlist.find(item => 
                item.colorname == this.$store.state.color || item.hex == this.$store.state.color
            );

            // 3. If a match is found, apply the settings
            if (activeColorItem) {
                this.$vuetify.theme.primary = activeColorItem.color
                
                // REUSABLE HELPER CALL: Synchronize system panel with loaded preferences
                updateMobileSystemBar(activeColorItem.hex)
            }

            // 4. Left nav mini
            this.miniVariant = JSON.parse(this.$store.state.leftNavMini)

            // 5. Right nav mini
            this.miniRight = JSON.parse(this.$store.state.rightNavMini)
        },
        async updateTheme(theme) {
            this.darkTheme = theme=='dark' ? true : false      
            const data = {"email": this.$store.state.email, "theme": theme}
            await userApi.updateTheme(data);
        },
        async setLeftMiniUpper() {
            this.miniVariant = !this.miniVariant
    
            if (this.miniVariant != this.$store.state.leftNavMini) {
                this.$store.commit('setLeftNavMini', this.miniVariant)
                const data = {"leftNavMini": this.miniVariant, "rightNavMini": this.miniRight}
                const response = await userApi.updateUINav(data);
            }
        },
        async setLeftMini() {
            if (this.miniVariant) 
                this.miniVariant = !this.miniVariant 
    
            if (this.miniVariant != this.$store.state.leftNavMini) {
                this.$store.commit('setLeftNavMini', this.miniVariant)
                const data = {"leftNavMini": this.miniVariant, "rightNavMini": this.miniRight}
                const response = await userApi.updateUINav(data);
            }
        },
        async logout() {
            const logoutData = {
                userId: this.$store.state.userId,
                sessionId: localStorage.sessionId,
                logoutCode: "user_initiated",
                logoutMessage: "User Initiated",
            }
            await auth.logout(logoutData)
        },
        setHeaderTitles(data) {
            this.headerTitle = data.headerTitle
            this.isMainMenu = data.isMainMenu
            this.headerPageTitle = data.headerPageTitle
            this.avatarPath = data.avatarPath
            this.companyLogo = data.companyLogo
            this.isTeamPage = data.isTeamPage

            if (data.headerImgPath) {
                this.$refs.refHederCard.setHeaderImageMain()
            }
        },
        setDrawer() {
            //TODO device sizes
            if (window.innerWidth > 1000) {
                this.drawer = true
                this.drawerRight = true
            }else{
                this.drawer = false
                this.drawerRight = false
            }
        },
        setComponentsEvents() {
            //called from individual component to change common header titles
            this.$root.$on('setHeaderTitles', (data) => {
                this.setHeaderTitles(data)
            })
    
            //called from Settings page (colors component)
            this.$root.$on('updateTheme', (theme) => {
                if (theme == 'light' || theme == 'dark') {
                    this.updateTheme(theme)
                }   
            })
    
            this.$root.$on('updateHeaderCompanyLogo', (data) => {
                if (data=='updateHeaderCompanyLogoHandler') {
                    this.$refs.companyLogoRef2.src = `${this.savedCompanyLogo}?date=${Date.now()}`
                }
            })
        },
        updateNotifBadge(data) {
            //don't update notif badge if active page is Notifications or the page item
            var currentRoute = this.$router.currentRoute.path
            if (!currentRoute.includes('notifications') && !currentRoute.includes(data.itemLink)) {
            this.getUnreadNotifications()
            }
        },
        async getAccessRights() {
            try {
                const response = await appsApi.getAccessRights()
                if (response.status==200) {
                    this.user_apps_list = JSON.parse(JSON.stringify(response.data.applications))
                    this.$store.commit('setUserAppsList', this.user_apps_list)
                }
            }catch(error){
                this.error = true
            }
        },
        async getFiscalPeriods() {
            try {
                const response = await fiscalPeriodsApi.getByCompany()
                if (response && response.status == 200) {
                    this.$store.commit('setFiscalPeriods', response.data.items.reverse())
                    this.$store.commit('setCutOffSettings', response.data.cutOffSettings)
                }
            }catch(error){
                this.error = true
            }
        },
        incrementTime() {            
            var current_time = this.$moment(this.$store.state.loginTimer).add(1, 'minutes')
            this.$store.commit('setLoginTimer', current_time)
            var start = this.$moment(this.$store.state.loginStartTime)
            var durationTotal = this.$moment.duration(this.$moment(current_time).diff(this.$moment(start)))
            
            //logout if no activity in 30mins
            var sessionMin = parseInt(durationTotal.minutes())
            
            console.log('sessionMin: ', parseInt(sessionMin))
            console.log('VUE_APP_PAGE_TIMEOUT: ', parseInt(process.env.VUE_APP_PAGE_TIMEOUT))
            
            if (parseInt(sessionMin) > parseInt(process.env.VUE_APP_PAGE_TIMEOUT)) {
                clearInterval(this.login_timer)
                const logoutData = {
                    logoutCode: "expired",
                    logoutMessage: "No Page Activity",
                    userId: this.$store.state.userId
                }
                auth.logout(logoutData)
            }
        },
        setLoginTimer() {
            if (this.login_timer) {
                clearInterval(this.login_timer)
            }

            this.$store.commit('setLoginStartTime', new Date())
            this.$store.commit('setLoginTimer', new Date())

            //initialize idle timer
            //this.login_timer = setInterval(this.incrementTime, parseInt(60000))   //1min interval
            this.login_timer = setInterval(() => this.incrementTime(), 60000)       //1min interval
        },
        mousedown(event) {
            //clear idle timer on mouse click
            this.$store.commit('setLoginStartTime', new Date())
            this.$store.commit('setLoginTimer', new Date())
        },
        updateConnectionStatus() {
            this.showSnackbar = !navigator.onLine;
            this.snackBarMsg = 'You have no internet connection.'
        },
        initialize() {
            this.colorlist = colorlist
            this.setUserSettings()
            this.setHeaderImage()
            this.getAccessRights()
            this.getFiscalPeriods()
            this.setDrawer()
            this.setLoginTimer()
            this.getUnreadNotifications()
            this.updateConnectionStatus()

            this.$store.commit('setPassword', '')
            window.addEventListener('mousedown',this.mousedown)
            window.addEventListener('online', this.updateConnectionStatus)
            window.addEventListener('offline', this.updateConnectionStatus)

            this.setComponentsEvents()
        }
    }, 
    created () {  
        this.initialize()
        this.$root.$on('switchAccount', () => {
            this.initialize()
            this.$refs.refHederCard.setHeaderImageMain()
        })
    },
    beforeDestroy() {
        this.$root.$off('switchAccount')
        this.$root.$off('setHeaderTitles')
        this.$root.$off('updateTheme')
        this.$root.$off('updateHeaderCompanyLogo')
    },
    computed: {
        loggedIn() {
            return auth.loggedIn()
        },
        savedCompanyLogo() {
            var logo = this.$store.state.companyLogo? this.$store.state.companyLogo : 'default.png'
            return `${process.env.VUE_APP_COMPANY_LOGO_URL}${logo}`
        },
        environment() {
            if (window.location.href.toString().includes('localhost')) {
                return '(Local Environment)'
            }else if (window.location.href.toString().includes('test')) {
                return '(Test Environment)'
            }else{
                return ''
            }
        },
        notications() {
            if (this.$store.state.unclickedNotifCount) {
                if (this.$store.state.unclickedNotifCount > 99) {
                    return '99+'
                }else{
                    return this.$store.state.unclickedNotifCount
                }
            }
        },
        isManagingLinkedAccount() {
            return this.$store.state.isLinkedAccount
        },
        dialogOkCancelMsg() {
            return `You are currently managing the linked account for <b>${this.linkedAccountCompanyName}</b>. Click OK to return to your parent account.`
        },
        linkedAccountCompanyName() {
            return this.$store.state.companyAccount.companyName
        }
    },
    beforeDestroy() {
        clearInterval(this.login_timer)
    },
    destroyed() {
        clearInterval(this.login_timer)
        window.removeEventListener('mousedown',this.mousedown);
    },
}
</script>
<style scoped>
.leftnav-content-text {
    margin-left:-10px;
}
.leftnav-content-text-sub {
    margin-left:-10px;
}
.leftnav-avatar-box {
    margin:15px 0px 5px 0px; 
    cursor:pointer;
}
.leftnav-mini-button {
    position:fixed; 
    bottom:5px; 
    right:0px;
}
.footer-container {
    width:100%;
    cursor:pointer;
    font-size:12px;
    font-family:Roboto;
}
.logo-text {
    font-family: 'Inter', sans-serif !important;
    font-size: 18px;
    font-weight: 300 !important; /* Added !important to guarantee it stays Light */
    text-transform: none !important; /* Prevents Vuetify from capitalizing the title */
    color: white;
}
.header-env {
    margin-left: 5px;
    font-style: italic;
    font-weight: bold;
}

/* this can be inproved in the future by creating a header toolbar component, but may take time */
.content-container {
    margin:-43px 2px 2px 2px !important;
}
</style>